export default __webpack_public_path__ + "static/media/logo_Visura.7a666f01.png";